'use client';

import FeedbackWidget from './FeedbackWidget';
import { useAuth } from './AuthProvider';
import { useFeedback } from '../contexts/FeedbackContext';

/**
 * Global wrapper for FeedbackWidget that provides user context.
 * Shows on all pages when user is authenticated.
 */
export default function GlobalFeedbackWidget() {
  const { user } = useAuth();
  const { playableId } = useFeedback();

  // Only show for authenticated users
  if (!user) {
    return null;
  }

  return <FeedbackWidget playableId={playableId} userId={user.id} userEmail={user.email} />;
}
